const LayoutTest = () => {
    return (
        <div className="w100p h100vh dpFlx flxdCol">
            <div className="w100p h40 bgcBtnConfirm"></div>
            <div className="w100p dpFlx" style={{flex: "1 0 auto"}}>
                <div className="w58 bgcBlueviolet"></div>
                <div className="w280 bgcBtnClose"></div>
                <div className="dpFlx flxdCol" style={{flex: "1 0 auto"}}>
                    <div className="w100p h28 bgcE60000"></div>
                    <div className="w100p h30 bgcOrange"></div>
                    <div className="dpFlx" style={{flex: "1 0 auto"}}>
                        <div className="dpFlx bgc007CE8" style={{flex: "1 0 auto"}}></div>
                        <div className="w280 bgc96c832"></div>
                        <div className="w715 bgc2882B7"></div>
                    </div>
                    <div className="w100p h300 bgc804040"></div>
                    <div className="w100p h30 bgcBlack"></div>
                </div>
            </div>
        </div>
    )
}
export default LayoutTest;